import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMotorcycle, faCar, faEdit, faL, faPlus, faSort, faTrash, faEllipsisVertical, faTrashCan, faPenToSquare, faPaperclip, faBuilding, faChessQueen, faClock, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
 
import "./visitorLinkPage.css"
import { useEffect, useState } from "react";
import { faCalendar } from "@fortawesome/fontawesome-free-solid";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { commonAPI } from "../../services/CommonAPIService";
import { ToastContainer, toast } from "react-toastify";
import logo from "../../assets/img/CuronextFinal.png"
import Nodataimg from "../../assets/img/denied.png"
import logoWhite from "../../assets/img/CuronextFinalWhite.png"

const VisitorLinkPage = () => {
    const [VehicleType, setVehicleType] = useState("4WHEELER")
    const [VehicleTypeBtnBike, setVehicleTypeBtnBike] = useState(false);
    const [VehicleTypeBtnCar, setVehicleTypeBtnCar] = useState(true);
    const [vehicleNumber, setVehicleNumber] = useState("")
    const [key, setKey] = useState("")
    const [visitorInfo, setVisitorInfo] = useState("")
    const navigate = useNavigate();
    const location = useLocation();
    const [updateLpNumber, setUpdateLpNumber] = useState()
    // const queryParams = new URLSearchParams(location.search.split('?')[1]);
    const [data,setdata] = useState(false)
    const [BuildingId,setBuildingId] = useState("")
    const [NoData,setNoData] = useState(false)

    const MasterUrl = process.env.REACT_APP_MASTER_API 
    useEffect(() => {
        // Ensure you have location available
        const queryParams = new URLSearchParams(location.search); // Assuming location.search contains the query string
        
        const idParam = queryParams.get('id');
        const qParam = queryParams.get('q')?.replace(/ /g, '+'); // Replace spaces with '+', if needed
    
        setKey(qParam);
        setBuildingId(idParam);
    
        console.log("id:", idParam); // Output: 1155
        console.log("q:", qParam);   // Output: lDNCEL8lu2vxoi_hCROSSQ
    
        // Check if qParam exists
        if (qParam) {
            const getInfo = async () => {
                try {
                    // API call
                    const response = await fetch(`${MasterUrl}/api/Visitor/GetInviteVisitor`, {  
                        // const response = await fetch('https://api.curonext.com/api/Visitor/GetInviteVisitor', {    
                        method: 'POST',
                        body: JSON.stringify({
                            "key": qParam.toString()
                        }),
                        headers: {
                            'Content-Type': 'application/json',
                            buildingId: idParam // Ensure 'idParam' is used correctly
                            // AppSecretKey: idParam,
                        }
                    });
    
                    // Handle JSON parsing
                    const result = await response.json();
                    
                    // Check for success in API response
                    if (result.success === true) {
                        console.log("response , ApigetParamete", result, qParam.toString());
                        
                        // Update state
                        setVisitorInfo(result?.data);
                        setUpdateLpNumber(result?.data?.lpNumber);
                        setdata(false);
                        setNoData(false);
    
                        // Handle vehicle type
                        if (result?.data?.vehicleType?.toUpperCase() === "4WHEELER") {
                            VehicleCar();
                        } else {
                            VehicleBike();
                        }
                    } else {
                        // toast.warning("Something went wrong");
                        setNoData(true);
                    }
                } catch (error) {
                    console.log(error);
                    toast.warning("An error occurred while fetching data.");
                }
            };
    
            // Call the async function
            getInfo();
        }
    }, [location.search, data]); 
    const VehicleCar = async () => {
        setVehicleTypeBtnCar(true)
        setVehicleTypeBtnBike(false)
        setVehicleType("4WHEELER")
    }
    const VehicleBike = async () => {
        setVehicleTypeBtnCar(false)
        setVehicleTypeBtnBike(true)
        setVehicleType("2WHEELER")
    }
    // const handleClick = () => {
    //     navigate('/inv?q=5X8FKqZF/J9BH83rajj7nQ==');
    // };
 
    function convertDate(dateString) {
        const date = new Date(dateString);
 
        // Get the day, year, month name, and time
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        const monthName = date.toLocaleString('default', { month: 'short' }).toLowerCase();
        const hours = String(date.getHours()).padStart(2);
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
 
        // Format the new date-time string
        return <span>
            {`${day}-${monthName}-${year} `}
            <FontAwesomeIcon icon={faClock} />
            {` ${hours}:${minutes}`}
        </span>
    }
 
    async function vehicleNumberUpdate() {
        console.log("sas")
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
       
        const bodyReq = {
            "visitorTransitId": visitorInfo?.visitorTransitId,
            "displayVisitorName": visitorInfo?.displayVisitorName,
            "lpNumber": updateLpNumber,
            "vehicleType": VehicleType
        }
        console.log(bodyReq,"BODYREQ")
        try {
            // const endPointVariableKey    = {
            //     buildingId: visitorInfo?.buildingId
           
            //   }
            //   console.log(endPointVariableKey,"End")
            // const response = await commonAPI("updateVehicleNumber", bodyReq, endPointVariableKey)
            const response = await fetch(`${MasterUrl}/api/Visitor/InviteVisitor`, {    
            // const response = await fetch('https://api.curonext.com/api/Visitor/InviteVisitor', {        
                method: 'POST',
                body: JSON.stringify({
                    "visitorTransitId": visitorInfo?.visitorTransitId,
                    "displayVisitorName": visitorInfo?.displayVisitorName,
                    "lpNumber": updateLpNumber,
                    "vehicleType": VehicleType
                }),
                headers: {
                    'Content-Type': 'application/json',
                    buildingId: visitorInfo?.buildingId
                    // AppSecretKey: visitorInfo?.buildingId,
                }
            });
            const result = await response.json();
            console.log(result,"Response")
            if (result?.success === true) {
                // console.log(result,"Response")
                // setVisitorInfo(result?.data)
                toast.success("Vehicle number updated")
                setdata(true)
            }
            else {
                toast.warning(result?.message[0])
            }
        } catch (error) {
            console.log(error)
        }
    }
 
    return (<>
        <div className="Invitation">
            <div className="container">
                <div className="row justify-content-center">
                    <div className=" col-lg-6 col-md-offset-3 col-sm-12 col-12">
                        {!NoData ?
                            <div className="borderwidth">
                                {/* <div>
                                    <button onClick={handleClick}>Go to Visitor Link Page</button>
                                </div> */}
                                <div className="invite_card">
                                <img src={logo} style={{ width: "240px",borderBottom:'1px' }} className="img img-responsive" />
                                </div>
                                <div className="subhead">
    
                                    <h3 >Dear {visitorInfo?.displayVisitorName} </h3>
                                </div>
                                <div className="inviteText">
    
                                    <p>You are Invited by &nbsp;<b>{visitorInfo?.createdUserName 
                                    } </b>&nbsp; using CURONext</p>
                                </div>
                                <div className="date_time">
                                    <h6> On </h6>
                                    <span> <FontAwesomeIcon icon={faCalendar}></FontAwesomeIcon>  {convertDate(visitorInfo?.visitStartDt)}{/**/} </span>
    
    
                                </div>
                                <div className="Location">
                                    <h6> At </h6>
                                <span><FontAwesomeIcon icon={faBuilding}></FontAwesomeIcon>    {visitorInfo?.buildingName ? visitorInfo?.buildingName + "-" : ""}{visitorInfo?.towerName ? visitorInfo?.towerName + "," : ""} {visitorInfo?.addressLine1 ? visitorInfo?.addressLine1 + "," : ""} {visitorInfo?.addressLine2 ? visitorInfo?.addressLine2 + "," : ""} {visitorInfo?.city ? visitorInfo?.city + "," : ""}  {visitorInfo?.pinCode ? "Pincode-" + visitorInfo?.pinCode + "," : ""} {visitorInfo?.state ? visitorInfo?.state + "" : ""}</span>
    
                                </div>
                                <div className="note">
                                    <p><FontAwesomeIcon icon={faExclamationCircle}></FontAwesomeIcon> Kindly fill your vehicle detail for seamless entry in the premises</p>
                                </div>
    
                                <div className="col-md-12 mb-2 text-center">
                                    <div className='fam_vehicleBtn'>
                                    
                                        {VehicleTypeBtnCar ?
                                            <FontAwesomeIcon icon={faCar} onClick={() => VehicleCar()} className='fam_vehicleBtnicon bg-info text-white' />
                                            :
                                            <FontAwesomeIcon icon={faCar} onClick={() => VehicleCar()} className='fam_vehicleBtnicon text-info border-info' />
                                        }
                                        {VehicleTypeBtnBike ?
                                            <FontAwesomeIcon icon={faMotorcycle} onClick={() => VehicleBike()} className='fam_vehicleBtnicon bg-info text-white' />
                                            :
                                            <FontAwesomeIcon icon={faMotorcycle} onClick={() => VehicleBike()} className='fam_vehicleBtnicon text-info border-info' />
    
    
                                        }
                                    </div>
                                </div>
                                <div className="vehicleInput">
                                    <input type="text" value={updateLpNumber} onChange={(e) => { setUpdateLpNumber(e.target.value) }} placeholder="Enter Full Vehicle Number" />
                                </div>
    
                                <div className="invite-Submit">
                                    <button onClick={vehicleNumberUpdate}> Submit </button>
                                </div>
    
                                <div id="textField" className="appear" style={{ display: "none" }}>
                                    <img src="https://e7.pngegg.com/pngimages/341/867/png-clipart-white-check-with-green-background-illustration-fingerprint-comcast-circle-symbol-technology-tick-miscellaneous-angle.png" className="img img-responsive" />
    
                                    <p>Thank you, for submitting your Vehicle Details </p>
                                </div>
    
    
    
    
    
                    
    {/*  
                            <div className="ribbonbott">
                                    <img src={inviteback} className="img img-responsive" />
                                </div>   */}
                            </div>:
                            <div className="borderwidth" style={{height: "90vh"}}>
                                <div className="invite_card">
                                    <img src={logo} style={{ width: "240px",borderBottom:'1px' }} className="img img-responsive" />
                                </div>
                                <div className="invite_card mt-5">
                                    <img src={Nodataimg} style={{ width: "240px",borderBottom:'1px' }} className="img img-responsive" />
                                </div>
                                <div className="subhead mt-4">
    
                                    <h3 >Your link has expired. </h3>
                                </div>
                            </div>
                        }    
                    </div>
                </div>
 
 
 
            </div>
        </div>
        <ToastContainer />
    </>)
}
export default VisitorLinkPage